<template>
    <div class="expandable-cell-container w-full flex flex-wrap gap-0.5 items-center">
        <CountriesFromPayoutGroups 
          :payoutGroups="payoutGroupsSliced"
          :useFlags="useFlags"
        />
      <div
        v-if="
          payoutGroups.length > payoutGroupsSliced.length
        "
      >
      <VTooltip :delay="0">
      <a href="#" @click.prevent="toggleExpand" class="link text-base-content/30 hover:text-base-content/70 ml-1">
          + {{ payoutGroups.length }}
        </a>
        <template #popper>          
          <div>
            <DetailedCountriesFromPayoutGroups 
              :payoutGroups="payoutGroups"
            />
          </div>
        </template>
      </VTooltip>

      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  import { formatPayout } from '@/utils/formatCurrency'
  import CountriesFromPayoutGroups from '@/components/common/CountriesFromPayoutGroups.vue';
  import DetailedCountriesFromPayoutGroups from '@/components/common/DetailedCountriesFromPayoutGroups.vue';


  const props = defineProps({
    payouts: {
      type: Array,
      required: true
    },
    showCount: {
      type: Number,
      default: 5
    },
    useFlags: {
      type: Boolean,
      default: false
    }
  });
  
  const isExpanded = ref(false);
  
  const groupBy = (xs, key) => {
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  
  const computedPayouts = computed(() =>
    props.payouts.filter(
      payout =>
        !payout.isPaused && (payout.value > 0 || payout.value === null)
    )
  );
  
  const payoutGroups = computed(() =>
    Object.entries(groupBy(computedPayouts.value, 'countryCode'))
  );
  
  const payoutGroupsSliced = computed(() =>
    payoutGroups.value.slice(0, props.showCount)
  );
  
  const toggleExpand = () => {
    isExpanded.value = !isExpanded.value;
  };
  
  const getTooltipFromGroup = (payoutGroup, country) => {
    return payoutGroup
      .map(
        payout => (payout.rate ? country + ' - ' + formatPayout(payout.rate, payout.type) : country)
      )
      .join('<br/>');
  };
  </script>
  
  <style scoped>
  .expandable-cell-container {
    overflow-wrap: break-word;
  }
  </style>